import commonExtend from '../common/extend';

export default [
  ...commonExtend,

  // Add your forum extenders here
];
